var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.whitelabel.omDesign)?_c('omk-button',{attrs:{"button-type":"outlined-button","button-size":"small"},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")]):_c('button',{staticClass:"default-btn-funk",on:{"click":_vm.handleClick}},[_c('p',[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }